// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"styles__gradient-bg5__ybBKL","facilityName":"styles__facilityName__LNgq1"};